import React, { useEffect, useMemo, useState, useCallback } from 'react';
import './metrics.scss';
import Tabs from 'devextreme-react/tabs';
import TableauChart from './tableau';
import { useGetTableauTokenData } from '../../../features/cfi/metrics/api/get-tableau-token-data';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { useTitle } from '../../../contexts/title';
import MultiView from 'devextreme-react/multi-view';
import { useAuth } from '../../../contexts/auth';
import { Environment } from '../../../types/enums';
import { useParams } from 'react-router-dom';

export default function MetricsPage() {
    const tableauTokenData = useGetTableauTokenData();
    const { user } = useAuth();

    const pageTitle = useTitle();
    useEffect(() => {
        pageTitle.setTitle('Metrics')
    }, [pageTitle]);

    let items = useMemo(() => {
        return (user?.environment === Environment.Sage ?
            [{
                text: `SLA Dashboard`,
                id: 'tableauViz1',
                width: '1700px',
                height: '2227px',
                chartname: 'SageCFI-SLADashboard_16159972117190/SLAScreenDashboardStandard'
            },
            {
                text: `Store List`,
                id: 'tableauViz2',
                width: '1700px',
                height: '827px',
                chartname: 'SageCFI-StoreList/SageCFI-StoreList'
            },
            {
                text: `Store SLC`,
                id: 'tableauViz3',
                width: '1700px',
                height: '1127px',
                chartname: 'SageCFI-StoreSLC_16160848480010/CFISalesLessCancelsDashboard'
            },
            {
                text: `Avg LTR Scores`,
                id: 'tableauViz4',
                width: '1600px',
                height: '940px',
                chartname: 'SageCFI-AVGLTRScores/CFIAvgLTRScores'
            }]
            :
            [{
                text: `SLA Dashboard`,
                id: 'tableauViz1',
                width: '1700px',
                height: '2227px',
                chartname: 'SageSyncCFI-SLADashboard/SLADashboardStandard'
            },
            {
                text: `CFI Quick Glance`,
                id: 'tableauViz4',
                width: '1500px',
                height: '827px',
                chartname: 'SageSyncCFI-CustomerSurvey/CFIQuickGlance'
            },
            {
                text: `Store List`,
                id: 'tableauViz2',
                width: '1700px',
                height: '827px',
                chartname: 'SageSyncCFI-StoreList/SageCFI-StoreList'
            },
            {
                text: `Store SLC`,
                id: 'tableauViz3',
                width: '1700px',
                height: '1127px',
                chartname: 'SageSyncCFI-StoreSLC/SageCFISalesLessCancelsDashboard'
            }])
    }, []);

    const { tab } = useParams();
    const tabIndex = tab === null || tab === undefined ? 0 : items.findIndex(e => e.chartname.includes(tab));
    const [selectedItem, setSelectedItem] = useState(items[tabIndex]);

    return (
        tableauTokenData.isLoading
            ? <React.Fragment>
                <div className={'content-block'}>
                    <div className={'dx-card wide-card responsive-paddings'}>
                        <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                    </div>
                </div>
            </React.Fragment>
            : (
                <div className={'content-block'}>
                    <div className={'dx-card wide-card '}>
                        {
                            tableauTokenData.data.token == null || tableauTokenData.data.token == '-1'
                                ?
                                <div className={'responsive-paddings'}>
                                    <p>
                                        <span>If you don't have access, please contact </span>
                                        <a href={'mailto:sales@sagesurfaces.com'} >sales@sagesurfaces.com</a>
                                    </p>
                                </div>
                                :
                                <React.Fragment>
                                    <Tabs
                                        selectedItem={selectedItem}
                                        items={items}
                                        onItemClick={(e) => {
                                            setSelectedItem(items[e.itemIndex]);
                                        }}
                                    />
                                    <MultiView
                                        deferRendering={true}
                                        selectedItem={selectedItem}
                                        dataSource={items}
                                        itemComponent={TableauChart}
                                        loop={false}
                                    />
                                </React.Fragment>
                        }
                    </div>
                </div>

            )

    )
}


